export default __webpack_public_path__ + "static/media/Your.ETF.Benefits.tree.1990012c.jpg";